<template>
  <div>
    <a-form
      class="mt-3"
      :form="form.fc"
      v-bind="formItemLayout"
      @submit="submit"
      hideRequiredMark>
      <servertemplate v-if="isServertemplate" :decorators="decorators.servertemplate">
        <a-form-item :label="$t('compute.text_297', [$t('dictionary.project')])">
          <domain-project
            :fc="form.fc"
            :fd="form.fd"
            :decorators="{ project: decorators.project, domain: decorators.domain }"
            :form-draft-key="vmDraftFields.domainProject"
            :ignoreStorage="ignoreLocalFormStorage"
            @fetchDomainCallback="fetchDomainCallback"
            @fetchProjectCallback="fetchProjectCallback" />
        </a-form-item>
      </servertemplate>
      <!-- <a-divider orientation="left">{{$t('compute.text_300')}}</a-divider> -->
      <a-form-item v-if="!isServertemplate" :label="$t('compute.text_297', [$t('dictionary.project')])">
        <domain-project
          :fc="form.fc"
          :fd="form.fd"
          :decorators="{ project: decorators.project, domain: decorators.domain }"
          :form-draft-key="vmDraftFields.domainProject"
          :ignoreStorage="ignoreLocalFormStorage"
          @fetchDomainCallback="fetchDomainCallback"
          @fetchProjectCallback="fetchProjectCallback" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_228')" v-if="!isServertemplate">
        <a-input v-decorator="decorators.name" />
        <template v-slot:extra>
          <name-repeated
            res="servers"
            :name="form.fd.name"
            :default-text="$t('compute.text_893')" />
        </template>
      </a-form-item>
      <a-form-item :label="$t('common.description')" v-if="!isServertemplate">
        <a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" v-decorator="decorators.description" :placeholder="$t('common_367')" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_1041')" v-if="showReason">
        <a-input v-decorator="decorators.reason" :placeholder="$t('compute.text_1042')" />
      </a-form-item>
      <a-form-item class="mb-0" :label="$t('compute.text_498')">
        <bill :decorators="decorators.bill" :form="form" :provider-list="form.fi.providerList" :form-draft-key="vmDraftFields.bill" />
      </a-form-item>
      <a-form-item v-if="form.fd.billType === 'quantity' && !isServertemplate" :label="$t('compute.text_1132')">
        <duration useServerDuration :decorators="decorators.duration" :form="form" :form-draft-key="vmDraftFields.duration" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_294')" v-show="!isServertemplate">
        <a-input-number v-decorator="decorators.count" @blur="countBlur" :min="1" :max="100" />
      </a-form-item>
      <a-form-item :label="$t('regionMap.enable_world_map')">
        <a-switch v-decorator="decorators.enableWorldMap" @change="onWorldMapModeChange" />
      </a-form-item>
      <a-form-item v-if="form.fd.enableWorldMap" :label="$t('compute.region_map')">
        <region-map
          :region-filter-params="regionMapParams"
          filter-brand-resource="compute_engine"
          :region-mapper="filterMapCloudregionList"
          split-key="provider"
          @select="onRegionSelect"
          @params-change="onRegionMapParamsChange" />
      </a-form-item>
      <area-selects
        class="mb-0"
        v-if="showAreaSelect"
        :wrapperCol="formItemLayout.wrapperCol"
        :labelCol="formItemLayout.labelCol"
        ref="areaSelectRef"
        :providerParams="providerParams"
        :cloudregionParams="areaCloudregionParams"
        :zoneParams="zoneParams"
        :provider-multiple="true"
        :cloudregion-multiple="true"
        :zone-multiple="true"
        :cloudregion-mapper="filterCloudregionListByProvider"
        :zone-mapper="filterZoneListByProvider"
        :defaultActiveFirstOption="areaDefaultActiveFirstOption"
        filterBrandResource="compute_engine"
        @providerFetchSuccess="providerFetchSuccess"
        @fetchsDone="onAreaSelectsFetchsDone" />
      <!-- <a-form-item class="mb-0" :label="$t('compute.text_1159')">
        <resource :decorator="decorators.resourceType" />
      </a-form-item> -->
      <a-form-item :label="$t('compute.text_1058')" class="mb-0">
        <cpu-radio :decorator="decorators.vcpu" :options="form.fi.cpuMem.cpus || []" :showUnlimited="true" :form="form" :form-draft-key="vmDraftFields.vcpu" @change="cpuChange" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_369')" class="mb-0">
        <mem-radio :decorator="decorators.vmem" :options="form.fi.cpuMem.mems_mb || []" :showUnlimited="true" :form-draft-key="vmDraftFields.vmem" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_109')">
        <sku
          ref="skuRef"
          v-decorator="decorators.sku"
          :priceUnit="skuPriceUnit"
          :type="type"
          :sku-params="skuParam"
          :hypervisor="hypervisor"
          :hasMeterService="hasMeterService"
          :init-sku-data="initSkuData"
          :form-draft-key="vmDraftFields.sku" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_15')">
        <base-select
          resource="cloudproviders"
          v-decorator="decorators.cloudprovider"
          :params="policycloudproviderParams"
          :isDefaultSelect="true"
          :showSync="true"
          :select-props="{ placeholder: $t('compute.text_149') }"
          @update:item="cloudproviderSelected" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_267')" :extra="$t('compute.text_302')">
        <os-select
          :type="type"
          :form="form"
          :types="osSelectTypes"
          :hypervisor="hypervisor"
          :decorator="decorators.imageOS"
          :os-arch="osArch"
          :imageParams="imageParams"
          :cacheImageParams="cacheImageParams"
          :cloudproviderParamsExtra="cloudproviderParamsExtra"
          :ignore-storage="ignoreLocalFormStorage"
          :form-draft-key="vmDraftFields.osSelect"
          @updateImageMsg="updateFi" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_49')" class="mb-0">
        <system-disk
          ref="systemDiskRef"
          v-if="form.fd.sku"
          :decorator="decorators.systemDisk"
          :type="type"
          :form="form"
          :hypervisor="hypervisor"
          :sku="form.fd.sku"
          :capability-data="form.fi.capability"
          :image="form.fi.imageMsg"
          :isServertemplate="isServertemplate"
          is-iops-show
          is-throughput-show
          :form-draft-key="vmDraftFields.systemDisk" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_50')">
        <data-disk
          v-if="form.fd.sku"
          :isInitForm="isFormBackfill"
          :decorator="decorators.dataDisk"
          :type="type"
          :form="form"
          :hypervisor="hypervisor"
          :sku="form.fd.sku"
          :defaultType="form.fd.systemDiskType"
          :capability-data="form.fi.capability"
          :isServertemplate="isServertemplate"
          ref="dataDiskRef"
          is-iops-show
          is-throughput-show
          :form-draft-key="vmDraftFields.dataDisk" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_1372')" v-if="showServerAccount">
        <server-account :form="form" :hypervisor="hypervisor" :instance_capabilities="form.fi.capability.instance_capabilities" :osType="osType" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_308')">
        <server-password :decorator="decorators.loginConfig" :loginTypes="loginTypes" :form="form" :form-draft-key="vmDraftFields.loginConfig" />
      </a-form-item>
      <a-alert
        v-if="needsSkuForAreaDownstream"
        type="info"
        show-icon
        :message="$t('regionMap.select_sku_first_tip')"
        class="mb-2" />
      <a-form-item :label="$t('compute.text_104')" class="mb-0">
        <server-network
          ref="networkRef"
          :form="form"
          :decorator="decorators.network"
          :network-list-params="networkParam"
          :schedtag-params="schedtagParams"
          :networkVpcParams="networkVpcParams"
          :vpcResource="vpcResource"
          :serverCount="form.fd.count"
          :networkResourceMapper="networkResourceMapper"
          :cloudprovider="form.fd.cloudprovider"
          :ignore-auto-network-type="ignoreAutoNetworkTypeForDraft"
          :form-draft-key="vmDraftFields.serverNetwork" />
      </a-form-item>
      <a-form-item :label="$t('compute.text_1154')" class="mb-0">
        <tag
          v-decorator="decorators.tag" :default-checked="tagDefaultChecked" />
      </a-form-item>
      <advance-config-block ref="advanceConfigBlock" collapsible>
        <eip-config
          v-if="enableEip"
          ref="eipConfigRef"
          :decorators="decorators.eip"
          :eip-params="eipParams"
          :hypervisor="hypervisor"
          :showBind="false"
          :isServertemplate="isServertemplate"
          :cloud-env="type"
          :form="form"
          :hasPublicIp="hypervisor === 'qcloud' || hypervisor === 'aliyun'"
          :formItemLayout="formItemLayout" :form-draft-key="vmDraftFields.eip" />
        <a-form-item v-if="!isServertemplate">
          <span slot="label">
            {{ $t('common_388') }}&nbsp;
            <a-tooltip :title="hostNameTips">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
          <host-name v-decorator="decorators.hostName" :isWindows="isWindows" />
        </a-form-item>
        <a-form-item :label="$t('compute.text_105')">
          <secgroup-config
            ref="secgroupConfigRef"
            :provider="hypervisor"
            :form="form"
            :decorators="decorators.secgroup"
            :secgroup-params="secgroupParams"
            :hypervisor="hypervisor"
            :showSecgroupBind="showSecgroupBind"
            :ignore-auto-type-reset="preserveAdvanceInitProps"
            :init-secgroups="workflowInitSecgroups" />
        </a-form-item>
        <a-form-item :label="$t('compute.text_311')" v-show="!isServertemplate" class="mb-0">
          <sched-policy
            ref="schedPolicyRef"
            :form="form"
            :provider="hypervisor"
            :server-type="form.fi.createType"
            :disabled-host="policyHostDisabled"
            :policy-host-params="policyHostParams"
            :decorators="decorators.schedPolicy"
            :hideCloudaccountSched="hideCloudaccountSched"
            :policy-schedtag-params="policySchedtagParams"
            :init-prefer-host="workflowInitPreferHost"
            :preserve-init-prefer-host="preserveAdvanceInitProps"
            :init-schedtags="workflowInitSchedtags"
            :form-draft-key="vmDraftFields.schedPolicy" />
        </a-form-item>
        <custom-data v-if="showCustomData" ref="customData" :decorators="decorators" :form="form" />
        <bastion-host ref="bastionHostRef" v-if="!isOpenSourceVersion && hasBastionService" :decorator="decorators.bastion_host" :form="form" :form-draft-key="vmDraftFields.bastionHost" />
      </advance-config-block>
      <bottom-bar
        :loading="submiting"
        :form="form"
        :errors.sync="errors"
        :type="type"
        :resourceType="form.fd.resourceType"
        :dataDiskSizes="dataDiskSizes"
        :isOpenWorkflow="isOpenWorkflow"
        :isOpenOrderSetWorkflow="isOpenOrderSetWorkflow"
        :isModifyWorkflow="isModifyWorkflow"
        :isServertemplate="isServertemplate"
        :hasMeterService="hasMeterService"
        :cloudaccountId="cloudaccountId"
        @add-cart="addShopCart"
        @cancel="handleCancel" />
    </a-form>
  </div>
</template>
<script>
/* eslint-disable */
import * as R from 'ramda'
import Bill from '@Compute/sections/Bill'
import { LOGIN_TYPES_MAP, BILL_TYPES_MAP } from '@Compute/constants'
import { resolveInitPreferZone } from '@Compute/utils/createServer'
import EipConfig from '@Compute/sections/EipConfig'
import SecgroupConfig from '@Compute/sections/SecgroupConfig'
import RegionMap from '@Compute/sections/RegionMap'
import { resolveValueChangeField } from '@/utils/common/ant'
import { PROVIDER_MAP, HYPERVISORS_MAP, isUcloudLikeHypervisor, resolveHypervisorKey } from '@/constants'
import { IMAGES_TYPE_MAP, getOsArchParam, isOsArch } from '@/constants/compute'
import AreaSelects from '@/sections/AreaSelects'
import { cloudregionFilterByCapability } from '@/utils/common/capability'
import mixin from './mixin'
export default {
  name: 'VMPublicCreate',
  components: {
    Bill,
    AreaSelects,
    EipConfig,
    SecgroupConfig,
    RegionMap,
  },
  mixins: [mixin],
  data () {
    return {
      cloudaccountId: '',
    }
  },
  computed: {
    // 是否为包年包月
    isPackage () {
      return this.form.fd.billType === BILL_TYPES_MAP.package.key
    },
    isArm () {
      return isOsArch(this.form.fd.sku && this.form.fd.sku.cpu_arch, 'arm')
    },
    isLoongarch64 () {
      return isOsArch(this.form.fd.sku && this.form.fd.sku.cpu_arch, 'loongarch64')
    },
    isRiscv64 () {
      return isOsArch(this.form.fd.sku && this.form.fd.sku.cpu_arch, 'riscv64')
    },
    osArch () {
      if (this.form.fd.sku && this.form.fd.sku.cpu_arch) {
        return this.form.fd.sku.cpu_arch
      } else {
        return ''
      }
    },
    showAreaSelect () {
      if (this.$store.getters.isAdminMode && this.$store.getters.l3PermissionEnable) {
        if (this.form.fd.domain && this.form.fd.domain.key) {
          return true
        } else {
          return false
        }
      }
      return true
    },
    areaDefaultActiveFirstOption () {
      if (this.isFormBackfill) return false
      return []
    },
    selectedCloudregionIds () {
      const { cloudregion } = this.form.fd
      if (Array.isArray(cloudregion)) return cloudregion.filter(Boolean)
      return cloudregion ? [cloudregion] : []
    },
    // 任一区域字段存在多个选中值
    hasMultipleAreaSelection () {
      const { provider, cloudregion, zone } = this.form.fd
      const isMultiValue = val => Array.isArray(val) && val.length > 1
      return isMultiValue(provider) || isMultiValue(cloudregion) || isMultiValue(zone)
    },
    // 未选 SKU 时，网络等下游暂不可用
    needsSkuForAreaDownstream () {
      return this.hasMultipleAreaSelection && !R.is(Object, this.form.fd.sku)
    },
    resolvedAreaFilterParams () {
      const { provider, cloudregion, zone, sku } = this.form.fd
      const fromForm = {
        provider: this.pickSingleAreaValue(provider),
        cloudregion: this.pickSingleAreaValue(cloudregion),
        zone: this.pickSingleAreaValue(zone),
      }
      if (R.is(Object, sku)) {
        return {
          provider: sku.provider || fromForm.provider,
          cloudregion: sku.cloudregion_id || fromForm.cloudregion,
          zone: sku.zone_id || fromForm.zone,
        }
      }
      if (this.hasMultipleAreaSelection) {
        return {}
      }
      return fromForm
    },
    cloudregionZoneParams () {
      const { cloudregion, zone } = this.resolvedAreaFilterParams
      const params = {}
      if (cloudregion) params.cloudregion = cloudregion
      if (zone) params.zone = zone
      this.applyAreaProviderFilter(params, this.providers)
      return params
    },
    networkParam () {
      if (!this.cloudregionZoneParams.cloudregion) return {}
      const { filter: areaFilter, ...areaParams } = this.cloudregionZoneParams
      const params = {
        filter: 'server_type.notin(ipmi, pxe, hostlocal)',
        usable: true,
        ...areaParams,
        ...this.scopeParams,
      }
      if (areaFilter) {
        const filters = Array.isArray(areaFilter) ? areaFilter : [areaFilter]
        filters.forEach(filter => this.appendSkuFilter(params, filter))
      }
      if (this.isGoogle) {
        params.show_emulated = true
      }
      return params
    },
    providers () {
      return this.normalizeAreaValues(this.form.fd.provider)
    },
    cloudregions () {
      return this.selectedCloudregionIds
    },
    providerParams () {
      return {
        usable: true,
        public_cloud: true,
        ...this.scopeParams,
      }
    },
    regionMapParams () {
      return {
        cloud_env: 'public',
        usable: true,
        show_emulated: true,
        read_only: false,
        capability: 'compute',
        public_cloud: true,
        // 触发 RegionMap 在计费方式变化时重新过滤点位
        billType: this.form.fd.billType,
        duration: this.form.fd.duration,
        ...this.scopeParams,
      }
    },
    areaCloudregionParams () {
      return {
        cloud_env: 'public',
        usable: true,
        show_emulated: true,
        ...this.scopeParams,
      }
    },
    zoneParams () {
      const params = {
        cloud_env: 'public',
        usable: true,
        show_emulated: true,
        order_by: 'created_at',
        order: 'asc',
        ...this.scopeParams,
      }
      this.applyAreaProviderFilter(params, this.providers)
      return params
    },
    imageParams () {
      const params = {}
      if (R.is(Object, this.form.fd.sku)) {
        params.os_arch = getOsArchParam(this.form.fd.sku.cpu_arch)
      }
      return params
    },
    cacheImageParams () {
      const { imageType } = this.form.fd
      const params = {}
      if (imageType !== IMAGES_TYPE_MAP.public.key) {
        params.manager_id = this.form.fd.cloudprovider
      }
      const { cloudregion } = this.cloudregionZoneParams
      if (cloudregion) {
        params.cloudregion_id = cloudregion
      }
      if (!params.cloudregion_id) return {}
      return params
    },
    eipParams () {
      if (!this.cloudregionZoneParams.cloudregion) return {}
      return {
        project: this.project,
        region: this.cloudregionZoneParams.cloudregion,
      }
    },
    skuPriceUnit () {
      if (this.isPackage) {
        return {
          key: 'month_price',
          unit: this.$t('compute.text_173'),
        }
      }
      return {
        key: 'hour_price',
        unit: this.$t('compute.text_172'),
      }
    },
    skuParam () {
      const params = {
        public_cloud: true,
        limit: 0,
        cpu_core_count: this.form.fd.vcpu,
        memory_size_mb: this.form.fd.vmem,
        usable: true,
        enabled: true,
        // manager: this.form.fd.cloudprovider,
        ...this.scopeParams,
      }
      const regionIds = this.cloudregions
      if (regionIds.length) {
        params.cloudregion_id = regionIds
      }
      const zoneValues = this.normalizeAreaValues(this.form.fd.zone)
      if (zoneValues.length) {
        params.zone_ids = zoneValues
      }
      const { values: skuProviderValues, explicit: hasExplicitProvider } = this.getSkuProviderValues()
      if (!this.applySkuProviderParam(params, skuProviderValues, hasExplicitProvider)) {
        return {}
      }
      if (this.form.fd.billType === 'quantity') {
        params.postpaid_status = 'available'
      } else if (this.form.fd.billType === 'package') {
        params.prepaid_status = 'available'
      }
      return params
    },
    policyHostParams () {
      const params = {
        show_emulated: true,
        resource_type: 'shared',
        enabled: 1,
        usable: true,
        limit: 0,
      }
      if (this.cloudregionZoneParams) {
        params.zone = this.cloudregionZoneParams.zone
        if (!params.zone) {
          params.cloudregion = this.cloudregionZoneParams.cloudregion
        }
      }
      if (!params.zone && !params.cloudregion) {
        return // 此时将不请求接口
      }
      return params
    },
    hypervisor () {
      if (R.is(Object, this.form.fd.sku)) {
        const { provider } = this.form.fd.sku
        if (provider) {
          return PROVIDER_MAP[provider].hypervisor
        }
      }
      return ''
    },
    loginTypes () {
      const loginTypes = { ...LOGIN_TYPES_MAP }
      const hypervisor = this.hypervisor
      if (isUcloudLikeHypervisor(hypervisor)) {
        delete loginTypes[LOGIN_TYPES_MAP.image.key]
        delete loginTypes[LOGIN_TYPES_MAP.keypair.key]
      }
      if (HYPERVISORS_MAP.aws.key === hypervisor) {
        delete loginTypes[LOGIN_TYPES_MAP.random.key]
        delete loginTypes[LOGIN_TYPES_MAP.password.key]
      }
      if (HYPERVISORS_MAP.azure.key === hypervisor) {
        delete loginTypes[LOGIN_TYPES_MAP.image.key]
      }
      if (HYPERVISORS_MAP.ctyun.key === hypervisor) {
        delete loginTypes[LOGIN_TYPES_MAP.image.key]
      }
      if (HYPERVISORS_MAP.qcloud.key === hypervisor) {
        delete loginTypes[LOGIN_TYPES_MAP.image.key]
      }
      if (this.form.fd.os === 'Windows') {
        // 以下平台在选择 windows 镜像时禁用关联密钥
        const disableKeypairHyper = [
          HYPERVISORS_MAP.azure.key,
          HYPERVISORS_MAP.aliyun.key,
          HYPERVISORS_MAP.qcloud.key,
          HYPERVISORS_MAP.ucloud.key,
          HYPERVISORS_MAP.rockbase.key,
          HYPERVISORS_MAP.esxi.key,
        ]
        if (disableKeypairHyper.includes(hypervisor)) {
          delete loginTypes[LOGIN_TYPES_MAP.keypair.key]
        }
        if (HYPERVISORS_MAP.google.key === hypervisor) {
          delete loginTypes[LOGIN_TYPES_MAP.keypair.key]
        }
      }
      if (this.isServertemplate) {
        delete loginTypes[LOGIN_TYPES_MAP.keypair.key]
        delete loginTypes[LOGIN_TYPES_MAP.password.key]
      }
      return Object.keys(loginTypes)
    },
    osSelectTypes () {
      if (HYPERVISORS_MAP.ctyun.key === this.hypervisor) {
        return ['public', 'public_customize']
      }
      return []
    },
    instanceSpecParams () {
      const params = {
        public_cloud: true,
        usable: true,
        enabled: true,
      }
      this.applyInstanceSpecRegionFilter(params, this.cloudregions)
      this.applyInstanceSpecZoneFilter(params, this.normalizeAreaValues(this.form.fd.zone))
      this.applyInstanceSpecProviderFilter(params, this.providers)
      return params
    },
    cloudproviderParamsExtra () {
      const params = {
        ...this.scopeParams,
      }
      const { cloudregion } = this.resolvedAreaFilterParams
      if (this.form.fd.sku && this.form.fd.sku.provider) {
        params.provider = this.form.fd.sku.provider
      }
      if (cloudregion) params.cloudregion = cloudregion
      return params
    },
    hideCloudaccountSched () {
      return !!this.form.fd.prefer_manager
    },
    policycloudproviderParams () {
      const params = {
        limit: 0,
        enabled: true,
        read_only: false,
        filter: 'status.equals(\'connected\')',
        ...this.scopeParams,
      }
      const { provider, cloudregion, zone } = this.resolvedAreaFilterParams
      if (provider) params.brand = provider
      if (cloudregion) params.cloudregion = cloudregion
      if (zone) params.zone = zone
      return params
    },
  },
  watch: {
    'form.fd.billType' (val, oldVal) {
      // form.fd 兄弟字段 $set 会误触发本 watch，同值直接跳过
      if (R.equals(val, oldVal)) return
      // 计费方式为包年包月平台不含 azure、aws，这里统一做清空处理
      if (val === BILL_TYPES_MAP.package.key) {
        this.form.fc.setFieldsValue({
          provider: [],
          cloudregion: [],
          zone: [],
        })
      }
      // AreaSelects 自身也 watch billType 会 fetchs；此处补拉平台列表
      this.$refs.areaSelectRef?.fetchs?.(['provider'])
    },
    'form.fd.duration' (val, oldVal) {
      if (R.equals(val, oldVal)) return
      if (this.form.fd.billType === BILL_TYPES_MAP.package.key) {
        if (val === '1W' || oldVal === '1W') {
          this.form.fc.setFieldsValue({
            provider: [],
            cloudregion: [],
            zone: [],
          })
          this.$refs.areaSelectRef?.fetchs?.(['provider', 'cloudregion', 'zone'])
        }
      }
    },
  },
  created () {
    // form.fd 任意兄弟 $set 会连带触发本 watch，需 equals 去重
    this.baywatch(['form.fd.provider', 'form.fd.cloudregion', 'form.fd.zone'], (val, oldVal) => {
      if (R.equals(val, oldVal)) return
      this.fetchInstanceSpecs()
    })
    this.baywatch(['form.fd.sku', 'form.fd.zone'], this.withFetchCapbilites)
    this.baywatch(['form.fd.sku'], this.onResolvedSkuChange)
  },
  methods: {
    onResolvedSkuChange (val, oldVal) {
      if (R.equals(val, oldVal)) return
      if (this.hasMultipleAreaSelection && R.is(Object, val)) {
        this.fetchInstanceSpecs()
      }
    },
    pickSingleAreaValue (value) {
      if (Array.isArray(value)) return value[0] || undefined
      return value || undefined
    },
    normalizeAreaValues (value) {
      if (Array.isArray(value)) return value.filter(Boolean)
      return value ? [value] : []
    },
    mapAreaProviderFilterValues (providerValues = []) {
      return providerValues.map(p => (
        PROVIDER_MAP[p]
          ? PROVIDER_MAP[p].provider
          : (HYPERVISORS_MAP[String(p).toLowerCase()]?.provider || p)
      ))
    },
    getAllProviderListValues () {
      return (this.form.fi.providerList || []).map(item => item.name).filter(Boolean)
    },
    getSkuProviderValues () {
      if (this.providers.length) {
        return { values: this.providers, explicit: true }
      }
      return { values: this.getAllProviderListValues(), explicit: false }
    },
    applySkuProviderParam (params, providerValues = [], explicit = false) {
      if (!providerValues.length) return false
      if (explicit && providerValues.length === 1) {
        params.provider = PROVIDER_MAP[providerValues[0]]
          ? PROVIDER_MAP[providerValues[0]].hypervisor
          : providerValues[0]
        return true
      }
      const providers = this.mapAreaProviderFilterValues(providerValues)
      this.appendSkuFilter(params, `provider.in(${providers.join(',')})`)
      return true
    },
    applyAreaProviderFilter (params, providerValues = []) {
      if (!providerValues.length) return
      if (providerValues.length === 1) {
        params.provider = PROVIDER_MAP[providerValues[0]]
          ? PROVIDER_MAP[providerValues[0]].hypervisor
          : providerValues[0]
        return
      }
      const providers = this.mapAreaProviderFilterValues(providerValues)
      params.filter = `provider.in(${providers.join(',')})`
    },
    applyInstanceSpecProviderFilter (params, providerValues = []) {
      const explicit = providerValues.length > 0
      const values = explicit ? providerValues : this.getAllProviderListValues()
      if (!values.length) return
      if (explicit && values.length === 1) {
        params.provider = PROVIDER_MAP[values[0]] ? PROVIDER_MAP[values[0]].hypervisor : values[0]
        return
      }
      const providers = this.mapAreaProviderFilterValues(values)
      this.appendSkuFilter(params, `provider.in(${providers.join(',')})`)
    },
    applyInstanceSpecRegionFilter (params, regionIds = []) {
      if (!regionIds.length) return
      if (regionIds.length === 1) {
        params.cloudregion = regionIds[0]
        return
      }
      this.appendSkuFilter(params, `cloudregion.in(${regionIds.join(',')})`)
    },
    applyInstanceSpecZoneFilter (params, zoneValues = []) {
      if (!zoneValues.length) return
      if (zoneValues.length === 1) {
        params.zone = zoneValues[0]
        return
      }
      this.appendSkuFilter(params, `zone.in(${zoneValues.join(',')})`)
    },
    refreshSkuByAreaSelection () {
      this.form.fc.setFieldsValue({ sku: undefined })
      this._setNewFieldToFd({ sku: undefined }, this.form.fc.getFieldsValue())
      this.$nextTick(() => {
        if (this.$refs.skuRef && typeof this.$refs.skuRef.fetchData === 'function') {
          this.$refs.skuRef.fetchData()
        }
        this.fetchInstanceSpecs()
      })
    },
    appendSkuFilter (params, filter) {
      if (!params.filter) {
        params.filter = [filter]
        return
      }
      if (!Array.isArray(params.filter)) {
        params.filter = [params.filter]
      }
      params.filter.push(filter)
    },
    getSelectedProviderNames () {
      return this.providers.map(p => String(p))
    },
    normalizeAreaProviderKey (val) {
      return resolveHypervisorKey(val)
    },
    isAreaProviderMatch (selected, itemProvider) {
      return this.normalizeAreaProviderKey(selected) === this.normalizeAreaProviderKey(itemProvider)
    },
    filterCloudregionListByProvider (list = []) {
      return this.filterAreaListByProvider(list)
    },
    filterZoneListByProvider (list = []) {
      return this.filterAreaListByProvider(list)
    },
    filterAreaListByProvider (list = []) {
      const providers = this.getSelectedProviderNames()
      if (!providers.length) return list
      return list.filter(item => {
        const raw = item.provider || item.brand || ''
        return providers.some(p => this.isAreaProviderMatch(p, raw))
      })
    },
    filterMapCloudregionList (list = []) {
      let result = cloudregionFilterByCapability({
        dataList: list,
        capability: this.$store.getters.capability,
        resource: 'compute_engine',
      })
      result = result.filter(item => {
        const provider = String(item.provider || item.brand || '').toLowerCase()
        return ![HYPERVISORS_MAP.jdcloud.key, HYPERVISORS_MAP.ecloud.key].includes(provider)
      })
      if (this.form.fd.billType === BILL_TYPES_MAP.package.key) {
        if (this.form.fd.duration === '1W') {
          result = result.filter(item => HYPERVISORS_MAP.aliyun.key === String(item.provider || '').toLowerCase())
        } else {
          result = result.filter(item => {
            const provider = String(item.provider || '').toLowerCase()
            return ![HYPERVISORS_MAP.azure.key, HYPERVISORS_MAP.aws.key, HYPERVISORS_MAP.google.key].includes(provider)
          })
        }
      }
      return result
    },
    toAreaValue (value) {
      if (value === undefined || value === null) return []
      return Array.isArray(value) ? value : [value]
    },
    matchProviderFromList (list, hypervisor) {
      const hvKey = resolveHypervisorKey(hypervisor) || String(hypervisor || '').toLowerCase()
      if (!hvKey || !list?.length) return null
      const hvObj = HYPERVISORS_MAP[hvKey]
      const hvProvider = String(hvObj?.provider || '').toLowerCase()
      return list.find(item => {
        const name = resolveHypervisorKey(item.name) || String(item.name || '').toLowerCase()
        const provider = resolveHypervisorKey(item.provider) || String(item.provider || '').toLowerCase()
        return name === hvKey ||
          provider === hvKey ||
          (hvProvider && (name === hvProvider || provider === hvProvider))
      }) || null
    },
    async applyMapSelectionToAreaSelects (regions = []) {
      const providerList = this.$refs.areaSelectRef?.providerList || this.form.fi.providerList || []
      const providerKeys = [...new Set(regions.map(item => {
        const raw = item.provider || item.brand
        if (!raw) return null
        const hvKey = resolveHypervisorKey(raw)
        const matched = this.matchProviderFromList(providerList, hvKey)
        return matched ? matched.name : hvKey
      }).filter(Boolean))]
      const cloudregionIds = regions.map(item => item.id).filter(Boolean)
      const areaFields = {
        cloudprovider: undefined,
        sku: undefined,
      }
      this.form.fc.setFieldsValue(areaFields)
      this._setNewFieldToFd(areaFields, this.form.fc.getFieldsValue())
      if (Object.prototype.hasOwnProperty.call(this.$data, 'cloudaccountId')) {
        this.cloudaccountId = ''
      }
      await this.$nextTick()
      const areaRef = this.$refs.areaSelectRef
      if (areaRef) {
        await areaRef.applyMultipleSelection({
          provider: this.toAreaValue(providerKeys),
          cloudregion: this.toAreaValue(cloudregionIds),
          zone: [],
        })
        this._setNewFieldToFd(this.form.fc.getFieldsValue(), this.form.fc.getFieldsValue())
      }
      this.refreshSkuByAreaSelection()
    },
    resolveDraftProviderNames (list = []) {
      const initData = this.effectiveInitFormData || {}
      let candidates = initData.extraData?.providers
      if (!Array.isArray(candidates) || !candidates.length) {
        const single = initData.extraData?.provider || initData.hypervisor
        candidates = single ? [single] : []
      }
      const names = []
      candidates.forEach((c) => {
        const matched = this.matchProviderFromList(list, c)
        if (matched && !names.includes(matched.name)) {
          names.push(matched.name)
        }
      })
      return names
    },
    resolveDraftPreferRegions () {
      const initData = this.effectiveInitFormData || {}
      const fromExtra = initData.extraData?.prefer_regions
      if (Array.isArray(fromExtra) && fromExtra.length) {
        return fromExtra.filter(Boolean)
      }
      return this.toAreaValue(initData.prefer_region).filter(Boolean)
    },
    /**
     * AreaSelects.fetchs 整链结束后再回填工单 initFormData（普通新建不落盘/不回填区域）
     */
    onAreaSelectsFetchsDone () {
      if (this._publicAreaApplying) {
        this._publicAreaRestoreAgain = true
        return
      }
      if (!this.isFormBackfill) return
      const list = this.$refs.areaSelectRef?.providerList || this.form.fi.providerList || []
      const providerNames = this.resolveDraftProviderNames(list)
      if (providerNames.length) {
        this.applyInitPublicAreaFields(providerNames)
      }
    },
    async applyInitPublicAreaFields (providerNames) {
      // 工单回填公有云 provider / region / zone（支持多选）
      const provider = this.toAreaValue(providerNames).filter(Boolean)
      if (!this.isFormBackfill || !provider.length) return
      if (this._publicAreaApplying) {
        this._publicAreaRestoreAgain = true
        return
      }
      this._publicAreaApplying = true
      try {
        const initData = this.effectiveInitFormData || {}
        const region = this.resolveDraftPreferRegions()
        const zone = this.toAreaValue(resolveInitPreferZone(initData, true)).filter(Boolean)
        const areaRef = this.$refs.areaSelectRef
        if (!areaRef) return

        // 先写 provider 并同步 fd，保证后续 cloudregion mapper / zoneParams 能读到平台
        this.form.fc.setFieldsValue({ provider })
        this._setNewFieldToFd({ provider }, this.form.fc.getFieldsValue())
        await this.$nextTick()

        if (typeof areaRef.fetchListsOnly === 'function') {
          await areaRef.fetchListsOnly(['cloudregion'], { skipDefaultSelect: true })
        }
        if (region.length) {
          this.form.fc.setFieldsValue({ cloudregion: region })
          this._setNewFieldToFd({ cloudregion: region }, this.form.fc.getFieldsValue())
          await this.$nextTick()
        }

        if (typeof areaRef.fetchListsOnly === 'function') {
          await areaRef.fetchListsOnly(['zone'], { skipDefaultSelect: true })
        }
        if (zone.length) {
          this.form.fc.setFieldsValue({ zone })
          this._setNewFieldToFd({ zone }, this.form.fc.getFieldsValue())
        }

        if (initData.prefer_manager_id) {
          this.form.fc.setFieldsValue({ cloudprovider: initData.prefer_manager_id })
          this._setNewFieldToFd({ cloudprovider: initData.prefer_manager_id }, this.form.fc.getFieldsValue())
        }
      } finally {
        this._publicAreaApplying = false
        if (this._publicAreaRestoreAgain && this.isFormBackfill) {
          this._publicAreaRestoreAgain = false
          this.$nextTick(() => this.onAreaSelectsFetchsDone())
        }
      }
    },
    providerFetchSuccess (list) {
      // 计费方式为包年包月平台不含 azure、aws、google
      if (this.form.fd.billType === BILL_TYPES_MAP.package.key) {
        if (this.form.fd.duration === '1W') {
          list = list.filter(item => HYPERVISORS_MAP.aliyun.key === item.name)
          this.form.fc.setFieldsValue({
            provider: this.toAreaValue(HYPERVISORS_MAP.aliyun.key),
          })
        } else {
          list = list.filter(item => {
            return ![HYPERVISORS_MAP.azure.key, HYPERVISORS_MAP.aws.key, HYPERVISORS_MAP.google.key].includes(item.name)
          })
        }
      }
      // 过滤京东云和移动云等只读的云
      list = list.filter(item => {
        return ![HYPERVISORS_MAP.jdcloud.key, HYPERVISORS_MAP.ecloud.key].includes(item.name)
      })
      // 仅缓存列表；平台/区域/可用区在 @fetchsDone 里回填，避免与 fetchs 竞态
      this.$set(this.form.fi, 'providerList', list)
      if (!this.providers.length) {
        this.$nextTick(() => {
          this.fetchInstanceSpecs()
        })
      }
      return list
    },
    onValuesChange (vm, changedFields) {
      this.$nextTick(() => {
        const formValue = this.form.fc.getFieldsValue()
        const newField = resolveValueChangeField(changedFields)
        this._setNewFieldToFd(newField, formValue)
        if (changedFields.schedPolicyType === 'host') {
          const keepHost = this.isFormBackfill ||
            this.form?.fi?.advanceDraftRestoring ||
            Object.prototype.hasOwnProperty.call(changedFields, 'schedPolicyHost') ||
            this.$refs.schedPolicyRef?.pendingPreferHost ||
            this.$refs.schedPolicyRef?._draftApplying
          if (!keepHost) {
            this.$set(this.form.fd, 'schedPolicyHost', undefined)
          }
        }
      })
    },
    async fetchCapability () {
      const params = {
        show_emulated: true,
        ...this.scopeParams,
        resource_type: this.form.fc.getFieldValue('resourceType'),
      }
      let id = this.cloudregionZoneParams.cloudregion
      let resource = 'cloudregions'
      if (this.cloudregionZoneParams.zone) {
        id = this.cloudregionZoneParams.zone
        resource = 'zones'
      }
      const capabilityParams = { id, spec: 'capability', params }
      if (!id) return
      if (R.equals(this.capabilityParams, capabilityParams)) return // 和已有的参数一样则不发请求
      this.capabilityParams = capabilityParams
      try {
        const { data } = await new this.$Manager(resource).getSpecific(this.capabilityParams)
        this.form.fi.capability = data
      } catch (error) {
        throw error
      }
    },
    async fetchInstanceSpecs () {
      try {
        const { data } = await this.serverskusM.get({ id: 'instance-specs', params: this.instanceSpecParams })
        this.form.fi.cpuMem = data
        const vcpuDecorator = this.decorators.vcpu
        const vcpuInit = vcpuDecorator[1].initialValue
        const cpu = this.form.fd.vcpu || vcpuInit
        this.cpuChange(cpu)
      } catch (error) {
        throw error
      }
    },
    withFetchCapbilites (val, oldVal) {
      if (val && !R.equals(val, oldVal)) {
        this.fetchCapability()
      }
    },
    cloudproviderLabel (item) {
      let label = item.name
      if (!this.usableCloudproviderMaps[item.id]) {
        if (item.status !== 'connected') {
          label += this.$t('compute.text_184')
        } else if (item.health_status !== 'normal') {
          label += this.$t('compute.text_185')
        } else if (item.enabled === false) {
          label += this.$t('compute.text_186')
        } else {
          label += this.$t('compute.text_187')
        }
      }
      return label
    },
    labelFormat (item) {
      if (this.form.fi.createType === SERVER_TYPE.public) {
        return `${item.account} / ${item.manager} / ${item.zone}`
      }
      return item.name
    },
    cloudproviderSelected (item) {
      this.cloudaccountId = item.cloudaccount_id || ''
    },
    cloudproviderUpdate (item) {
      this.cloudaccountId = item.cloudaccount_id || ''
    }
  },
}
</script>
